module.exports = __webpack_public_path__ + "static/facebook-icon-3006a271ca206eea88ca7aa2f843f4e6.png";